 <div *ngIf="menuItemsLayout === menuItemsLayoutEnum.ListMenu"
     class="size-price-btn-wrapper"
     [ngClass]="{
       'btn-width-max': buttonWidthMode === 'max',
       'btn-width-min': buttonWidthMode === 'min'
     }">
  <button ftsAuditableButton
          [auditName]="auditName"
          ftsAsyncButton
          class='btn fw-600 selection-text-color primary-bg-color btn-size-price shadowed text-center size-price-btn font-secondary'
          [subscription]="loadingSubscription"
          [disabled]="sizePrice?.isUnavailable || isPanelItemFundraiserAndOrdered || !!panelItem.pricePeriodMessage"
          (click)='addToOrder()'>

    <span class='fundraiser-entry block' *ngIf="panelItem.isFundraiser && !panelItem.pricePeriodMessage">{{(isPanelItemFundraiserAndOrdered ? 'component.size_price_button.applied' : 'component.size_price_button.add') | translate}}</span>
    <span class='special-entry block text-uppercase' *ngIf="panelItem.isSpecial && !panelItem.pricePeriodMessage">{{'component.size_price_button.select' | translate}}</span>
    <span class='block' *ngIf="panelItem.isItem && sizePrice.isAvailable && sizePrice.size === 'Size'">{{'component.size_price_button.order' | translate}}</span>
    <span class='block' *ngIf="(panelItem.isItem && sizePrice.size !== 'Size') && (panelItem.sizePrices.length > 1 || sizePrice.label !== sizePrice.size)">{{sizePrice.label}}</span>
    <span class='block price' *ngIf="panelItem.isItem && sizePrice.isAvailable">{{sizePrice.price | currency:'USD':'symbol'}}</span>
    <span class='block' *ngIf="panelItem.isItem && sizePrice.isFree">{{sizePrice.statusLabel}}</span>
    <span class='block' *ngIf="(panelItem.isItem && sizePrice.isUnavailable) || !!panelItem.pricePeriodMessage">{{'component.size_price_button.not_available' | translate}}</span>
  </button>
  <span
    *ngIf="sizePrice?.noticePeriod && shouldDisplayNoticePeriodMessage && hasCateringNoticeTime"
    class="selection-text-color notice-period">
    {{'component.size_price_button.prep_time' | translate}}{{formattedNoticePeriod}}
  </span>
</div>

<button *ngIf="menuItemsLayout === menuItemsLayoutEnum.CardMenu"
        ftsAuditableButton
        [auditName]="auditName"
        ftsAsyncButton
        [attr.aria-label]="'Add ' + panelItem.name + ' to order'"
        class='btn fw-600 text-center btn-block selection-btn font-secondary'
        [ngClass]="panelItem.isItem ? 'selection-bg-color selection-inverse-text-color primary-btn add-to-order-btn' : 'btn-link btn-undecorated primary-bg-color selection-text-color secondary-btn'"
        [subscription]="loadingSubscription"
        [disabled]="panelItem.isItem && (!sizePrice || sizePrice.isUnavailable) || isPanelItemFundraiserAndOrdered || !!panelItem.pricePeriodMessage"
        (click)='addToOrder()'>
  <div class="fw-500 text-uppercase" *ngIf="(panelItem.isItem && (!sizePrice || sizePrice.isUnavailable)) || !!panelItem.pricePeriodMessage">
    <span>{{'component.size_price_button.not_available' | translate}}</span>
  </div>
  <span class='fundraiser-entry text-uppercase' *ngIf="panelItem.isFundraiser && !panelItem.pricePeriodMessage">{{(isPanelItemFundraiserAndOrdered ?
    'component.size_price_button.applied' : 'component.size_price_button.add_to_order') | translate}}</span>
  <span *ngIf="(panelItem.isItem && sizePrice && (!sizePrice.isUnavailable)) && !panelItem.pricePeriodMessage" class='block text-uppercase'>
    <span class='add-to-text'>{{'component.size_price_button.add_to' | translate}}</span>{{'component.size_price_button.order' | translate}}
  </span>
  <span *ngIf="panelItem.isSpecial && !panelItem.pricePeriodMessage" class='block text-uppercase'>{{'component.size_price_button.select' | translate}}</span>
</button>

